import React from 'react';
import { resolveIcon } from '../../shared/resolveIcon';
import './Timeline.scss';

export interface TimelineInputs {
    hide: boolean;
    title: string;
    items: {
        dateText: string;
        title: string;
        icon: string;
    }[];
}

export const Timeline = ({ inputs }: { inputs: TimelineInputs }) => {
    if (inputs.hide) {
        return <></>;
    }

    return (
        <section className="paragraph__timeline kite-container">
            <h2 className="typestack-title-3">{inputs.title}</h2>
            <ul>
                {inputs.items.map((item, idx) => (
                    <li key={idx}>
                        <h3 className="typestack-title-6">{item.dateText}</h3>
                        <p>{item.title}</p>
                        <img src={resolveIcon(item.icon)} alt="" />
                    </li>
                ))}
            </ul>
        </section>
    );
};
